// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0e5db32e","977":"a6359b46"}[chunkId] + ".chunk.js";
};